@use './mixins' as mixin;
@use './variables' as variable;

html {
  background: #FCFCFC;
}

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root,
button,
a,
text,
input {
  font-family: "Segoe UI", system-ui, -apple-system, sans-serif;
}

button {
  cursor: pointer;
}

.App {
  margin: 0 auto;
  min-height: 100vh;
  @include mixin.calc(max-width, '1440px');

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
}

a {
  color: variable.$blue;
  text-decoration: none;
}

.secondary-btn {
  @include mixin.create-secondary-btn();
}

.primary-btn {
  @include mixin.create-primary-btn();
}

.button-as-link {
  border: 0;
  background: transparent;
  color: variable.$blue;
  font-size: 14px;
}

.text--red {
  color: #A4262C;
}

.text--orange {
  color: #F04E23;
}

.text--green {
  color: #107C10;
}

.text--blue {
  color: #0078D4;
}

@media screen and (prefers-contrast: more) {
  svg {
    fill: currentColor;
  }
}
